import { classNames } from "src/helpers/classNames";

const FormContainer = ({ children, className = "" }) => {
  return <div className={classNames("relative bg-white py-4 md:py-8 rounded-md flex px-4 flex-wrap justify-between w-full", className)}>{children}</div>;
};

export default FormContainer;
